export default __webpack_public_path__ + "static/media/Abel-Regular.20d14725.eot";